// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"of","cardInnerHeading":"oh","editButton":"oi","formClass":"oj","inputClass":"ok","pw":"ol","enterCurrentPw":"om","cancelButton":"on","submitButton":"oo"};